import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { BucketPaneEl } from 'common/widgets/bucket-pane';
export function template() {
  const {
    isMenuOpen
  } = this.state;
  return jsx("div", {
    sel: '.mp-bucket-selector'
  }, this.attr("label") ? jsx("div", {
    sel: '.mp-bucket-selector-label'
  }, this.attr("label")) : null, jsx(SelectEl, {
    attrs: {
      theme: "secondary",
      open: isMenuOpen,
      'selected-option': this.helpers.getDisplayedBucketLabel(),
      tooltip: {
        text: this.attr("tooltip-text")
      }
    },
    on: {
      menuChange: this.helpers.changeMenu
    }
  }, jsx("div", {
    sel: '.mp-bucket-selector-container',
    attrs: {
      slot: "body"
    }
  }, isMenuOpen ? jsx(BucketPaneEl, {
    attrs: this.helpers.getBucketPaneAttributes(),
    on: {
      changeSelectedBucket: this.helpers.propagateEvent,
      resetBucket: this.helpers.propagateEvent
    }
  }) : null)));
}